import {getSetting, setSetting} from './store';
import axios from 'axios';

import i18n from '../components/i18n';

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}


function posttelemetry(action, value) {

  if (getSetting('uid') === undefined) {
    //console.log('Setting new uid');
    let uid = uuidv4();
    setSetting('uid', uid);
  }
  let values = {};
  values.session_id = getSetting('uid');
  values.recorder = 'www';
  values.entrypoint = getSetting('entrypoint');
    
  values.selected_language = i18n.language;

  values.action = {
    key: action,
    data: {
      value
    }
  }
  //console.log(values);


  const api_url = process.env.API_URL + 'telemetry';
return axios.post(api_url, values) 
  .then(res => {
    return res.data;
  })
}
export default posttelemetry;
